import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { getDateConfiguration } from "../api/dateconfiguration"
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function NoticeSection({ setClosedCourses }) {
    const [dateConfigurations, setDateConfigurations] = useState([]);
    const [hoverIndex, setHoverIndex] = useState(null);
    const { institute } = useParams();
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    useEffect(() => {
        async function fetchDateConfigurations() {
            try {
                const response = await getDateConfiguration();
               // console.log("getDateConfiguration all=",response.data);
                const filteredConfigs = response.data.filter(
                    (config) => config.institute.instituteCode === institute
                );
                setDateConfigurations(filteredConfigs);
              //  console.log("Date config=", filteredConfigs)
                const closedCourses = filteredConfigs
                    .filter(config => isDateClosed(config.endDate))
                    .map(config => config.course.id);
               // console.log("Closed Courses:", closedCourses);
                setClosedCourses(closedCourses); // Pass closed courses
            } catch (error) {
                console.error("Error fetching date configurations:", error);
            }
        }
        fetchDateConfigurations();
    }, [institute, setClosedCourses]);

    const isDateClosed = (endDate) => {
        const currentDate = new Date();
        const endDateObj = new Date(endDate);
        return endDateObj < currentDate;
    };
    return (
        <>
            <div className="mt-8">
                <Container>
                    <Form.Label style={{
                        fontSize: "18px",
                        color: "#fff", fontWeight: "700", borderBottom: "1px solid #fff",
                        textTransform: "uppercase"
                    }} >Notice
                    </Form.Label>

                    <p className="mb-4" style={{ fontSize: "17px", textTransform: "uppercase", color: "#fff", fontWeight: "500" }}>
                        Important dates for online registration / Application
                    </p>

                    <div
                        style={{
                            maxHeight: "200px",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#fff transparent",
                            cursor: "pointer"
                        }}
                    >
                        {dateConfigurations.map((config, index) => (
                            <Row
                                key={index}
                                style={{
                                    marginTop: "5px",
                                    backgroundColor:
                                        hoverIndex === index
                                            ? "transparent"
                                            : "transparent",
                                    borderRadius: "5px",
                                    padding: "5px 16px",
                                    transition: "transform 0.3s",
                                    transform:
                                        hoverIndex === index
                                            ? "scale(1.05)"
                                            : "scale(1)",
                                }}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                            >
                                <Col
                                    sm={3}
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "700",
                                        color:
                                            hoverIndex === index
                                                ? "#fff"
                                                : "#fff",
                                    }}
                                >
                                    {config.course.courseName}
                                </Col>
                                <Col
                                    sm={8}
                                    style={{
                                        fontSize: "15px",
                                        color:
                                            hoverIndex === index
                                                ? "#fff"
                                                : "#fff",
                                    }}
                                >
                                    Starts: {config.startDate} {config.startTime} To End: {config.endDate}{" "}
                                    {config.endTime}
                                    {isDateClosed(config.endDate) && (
                                        <span style={{ color: "red", fontWeight: "bold", marginLeft: "10px" }}>* Closed</span>
                                    )}
                                    {/* Starts: {config.startDate} {config.startTime} To End: {config.endDate} {config.endTime} */}
                                </Col>
                            </Row>
                        ))}
                    </div>
                </Container>
            </div>
        </>
    );
}

export default NoticeSection;